@use '~@frontrow/console/css/variables.scss';

@forward '~@frontrow/console/css/variables.scss';

.demoAccountSearch {
  font-weight: bold;
  margin: variables.$std-margin-md 0 variables.$std-margin-md 0;
}

.findCreateButton {
  margin-left: variables.$std-margin-xs;
}

.formInline {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.formInput {
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  flex: 1;
}
